/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1683
 */

var r = require(/* 86 */"../1650/86/index")
var /* [auto-meaningful-name] */require_1263_$_1263$values = require(/* 1263 */"./1263").values
r({
  target: "Object",
  stat: true
}, {
  values: function (e) {
    return require_1263_$_1263$values(e)
  }
})
